import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/lib/api";
import { useCart } from "@/context/CartContext";

const SettingsContext = createContext(null);
export const useSettings = () => useContext(SettingsContext);

export function SettingsProvider({ children }) {
  const { selectedBranch } = useCart();
  const [settings, setSettings] = useState(null);
  const branchId = selectedBranch?.id || null;

  const load = useCallback(async () => {
    try {
      const q = branchId ? `?branch_id=${encodeURIComponent(branchId)}` : "";
      const { data } = await api.get(`/settings${q}`);
      setSettings(data);
    } catch {}
  }, [branchId]);

  useEffect(() => { load(); }, [load]);

  return (
    <SettingsContext.Provider value={{ settings, reload: load }}>
      {children}
    </SettingsContext.Provider>
  );
}
